class QrisService {
    decodeQRIS(qr) {
        let i = 0
        let result = {}

        while (i < qr.length) {
            let tag = qr.substr(i, 2)
            let len = parseInt(qr.substr(i + 2, 2))
            let val = qr.substr(i + 4, len)

            result[tag] = val
            i += 4 + len
        }

        return result
    }

    crc16(qrWithoutCRC) {
        let crc = 0xFFFF;

        for (let c = 0; c < qrWithoutCRC.length; c++) {
            crc ^= qrWithoutCRC.charCodeAt(c) << 8;
            for (let i = 0; i < 8; i++) {
                crc = (crc & 0x8000) ? ((crc << 1) ^ 0x1021) : (crc << 1);
                crc &= 0xFFFF;
            }
        }

        return crc.toString(16).toUpperCase().padStart(4, '0');
    }

    validateQris(qr) {
        const decoded = this.decodeQRIS(qr)

        const requiredTags = ["00","01","26","52","53","58","59","60","63"];

        for (const tag of requiredTags) {
            if (!decoded[tag]) throw new Error(`Tag ${tag} tidak ditemukan`)
        }

        const qrWithoutCRC = qr.slice(0, qr.length - 4);
        const expectedCRC = decoded["63"];
        const calculatedCRC = this.crc16(qrWithoutCRC);

        if (calculatedCRC !== expectedCRC) {
            throw new Error(`CRC tidak cocok`);
        }

        return decoded
    }
}

export default new QrisService